import React from "react";
import {ConditionalRenderer} from "./ConditionalRenderer";

interface PillButtonProps {
    onClick: React.MouseEventHandler<HTMLDivElement>;
    buttonText: string;
    containerClasses?: string;
    buttonClasses?: string;
    buttonTextClasses?: string;
    title?: string;
    leftIconSrc?: string;
    rightIconSrc?: string;
}

export let PillButton = function (props: PillButtonProps) {
    let containerClasses = `pill-button-container ${props.containerClasses || ''}`;
    let buttonClasses = `pill-button ${props.buttonClasses || ''}`;
    let buttonTextClasses = `pill-button-text ${props.buttonTextClasses || ''}`;
    let titleProps = {};
    if (props.title) {
        titleProps = {title: props.title}
    }
    return (
        <div
            className={containerClasses}
            {...titleProps}
        >
            <div
                className={buttonClasses}
                onClick={props.onClick}
            >
                <ConditionalRenderer if={props.leftIconSrc} renderer={() => (
                    <div className="pill-button-icon-container left">
                        <img
                            className="pill-button-icon"
                            src={props.leftIconSrc}
                        />
                    </div>
                )}/>
                <ConditionalRenderer if={props.buttonText} renderer={() => (
                    <div className={buttonTextClasses}>
                        {props.buttonText}
                    </div>
                )}/>
                <ConditionalRenderer if={props.rightIconSrc} renderer={() => (
                    <div className="pill-button-icon-container right">
                        <img
                            className="pill-button-icon"
                            src={props.rightIconSrc}
                        />
                    </div>
                )}/>
            </div>
        </div>
    );
};
